import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import Menu from './menu/Menu'
import Footer from './menu/Footer'
import ObliqueBox from '../pages/help/components/ObliqueBox'
import { NewMenu } from './menu/NewMenu'
import { ArchiveIcon, CarIcon, CogWheelIcon, HomeIcon, LogoutIcon, SupportIcon } from '../pages/home/components/icons'

const PageLayout = ({ children }) => {
  const { pathname } = useLocation()

  const userType = window.localStorage.getItem('userType') ?? 'fleet customer'
  const registerTripleClick = () => {
    let clicks = 0
    let timeout
    document.addEventListener('click', () => {
      clicks++
      if (clicks === 4) {
        
        window.localStorage.setItem('userType', userType === 'dealer' ? 'fleet customer' : 'dealer')
        window.location.reload()
      }
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        clicks = 0
      }, 300)
    })
  }

  registerTripleClick()
  return (
    <InnerLayout color={userType === "dealer" ? "white" : "var(--color-gray)"} collapse={true}>
      <div className="absolute text-center z-50 top-0 right-2 rounded-b-md bg-primary text-white p-4">
        <p className='w-fit whitespace-nowrap'>{userType}</p>
      </div>
      <div>
        {userType === 'dealer' ? (
          <div className="flex border flex-col items-center py-12 justify-between fixed h-full w-[60px] bg-white">
            <div className="flex  flex-col gap-8 items-center justify-center">
              <a className="pt-12" href="/" title="Home">
                <HomeIcon />
              </a>
              <a href="/cars" title="Cars">
                <CarIcon />
              </a>
              <a href="/archive" title="Archive">
                <ArchiveIcon />
              </a>
            </div>
            <div className="flex flex-col gap-8">
              <a href="/settings" title="Settings">
                <CogWheelIcon />
              </a>
              <a href="/support" title="Support">
                <SupportIcon />
              </a>
              <a href="/logout" title="Logout">
                <LogoutIcon />
              </a>
            </div>
          </div>
        ) : (
          <NewMenu collapse={true} />
        )}
      </div>
      {/*  <NewMenu handleCollapse={handleCollapse} collapse={!collapse}/> */}

      <ContentWrapper>
        <Content>{children}</Content>
      </ContentWrapper>
    </InnerLayout>
  )
}

export default PageLayout

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: scroll;
`
const InnerLayout = styled.div`
  display: grid;
  grid-template-columns: ${(p) => (p.collapse ? '75px' : '300px')} auto;
  background-color: ${(p) => p.color}; ;
  max-height: 100vh;
  width: 100%;
  overflow: none;
  position: absolute;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`
